import { getPortalId } from 'unified-navigation-ui/js/utils/getPortalId';
import { Metrics } from 'unified-navigation-ui/js/utils/metrics';
import { apiClientWithMiddleware } from 'unified-navigation-ui/utils/API';
import { GET_CONFIG_FAILURE, INACCURATE_NAV_CONFIG_RESPONSE } from '../constants/metrics';
import { RESET_NAV_CONFIG_CACHE_PARAM } from '../constants/navConfig';
import { getQueryParams } from '../utils/getQueryParams';
import { captureException } from '../utils/sentryAPI';
import { isNavConfigStale, navConfigCache } from './cache';
export const REVALIDATE_AFTER = 5000; // 5 seconds

const fetchNavConfig = () => {
  const portalId = getPortalId();
  const path = `/navconfig/v5/navconfig${portalId ? `?portalId=${portalId}` : ''}`;
  return apiClientWithMiddleware().get(path);
};
const onFetchError = err => {
  if (err.status !== 401) {
    // Only capturing actionable failures
    Metrics.counter(GET_CONFIG_FAILURE).increment();
    captureException(err);
  }
};
const maybeFlushNavConfigCache = () => {
  const queryParams = getQueryParams();
  const resetNavConfigParam = queryParams.get(RESET_NAV_CONFIG_CACHE_PARAM);
  if (resetNavConfigParam !== 'true') {
    return;
  }
  navConfigCache.delete();
};
const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
export const getCachedConfig = configCallback => {
  const portalId = getPortalId();
  maybeFlushNavConfigCache();
  const cachedConfig = portalId ? navConfigCache.get(portalId) : null;
  const isCachedConfigStale = cachedConfig ? isNavConfigStale(cachedConfig) : null;
  const storeIfAccurate = res => {
    if (!res) {
      return;
    }
    if (res.isAccurate && portalId) {
      navConfigCache.set(portalId, res);
    } else if (!res.isAccurate) {
      Metrics.counter(INACCURATE_NAV_CONFIG_RESPONSE).increment();
    }
  };
  if (cachedConfig && !isCachedConfigStale) {
    configCallback(cachedConfig);
    delay(REVALIDATE_AFTER).then(fetchNavConfig).then(storeIfAccurate).catch(onFetchError);
  } else {
    fetchNavConfig().then(res => {
      storeIfAccurate(res);
      configCallback(res);
    }).catch(error => {
      onFetchError(error);
      configCallback(null);
    });
  }
};